// Vendors
import { TitleComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Constants
import { BACKGROUND_MODAL_TITLE_COMPONENT_PROPS } from './constants/background-title.constants';
// Translations
import { BACKGROUND_TITLE } from './translations/background-title.translations';

const BackgroundTitleComponent = (): React.ReactNode => (
  <TitleComponent
    {...BACKGROUND_MODAL_TITLE_COMPONENT_PROPS}
    title={<FormattedMessage id={BACKGROUND_TITLE} />}
  />
);

export { BackgroundTitleComponent };
